<template lang="pug">
  div(
    class="keyboard"
    v-if="show")
  
    <!-- operators -->
    ul(class="keyboard-row")
      li(
        class="keyboard-button"
        v-for="op in operators"
        @click.stop.prevent="opPressed(op[0], op[2])")
        math-quill-view(class="keyboard-math" 
          :value="op[1] || op[0]")

    ul(class="keyboard-row")
      li(
        class="keyboard-button"
        v-for="func in functions"
        @click.stop.prevent="opPressed(func[0], func[2])")
        math-quill-view(class="keyboard-math" 
          :value="func[1] || func[0]")

    ul(class="keyboard-row")
      li(
        class="keyboard-button"
        v-for="c in constants"
        @click.stop.prevent="opPressed(c[0], c[2])")
        math-quill-view(class="keyboard-math" 
          :value="c[1] || c[0]")

    ul(v-if="customSymbols.length > 0"
      class="keyboard-row")
      li(
        class="keyboard-button"
        v-for="cs in customSymbols"
        @click.stop.prevent="customPressed(cs[0])")
        math-quill-view(class="keyboard-math" 
          :value="cs[1] || cs[0]")

</template>

<script>
  import MathQuillView from './MathQuillView'

  const operators = [
    ['+'],
    ['-'],
    ['\\cdot'],
    ['\\frac', '\\frac{x}{y}'],
    ['_', 'x_y'],
    ['^', 'x^y'],
    ['\\frac{d}{dt}', undefined, ['\\frac{d}{dt}', '\\frac{d}{dt}']],
    ['\\frac{d^2}{dt^2}', undefined, ['\\frac{d^2}{dt^2}', '\\frac{d}{dt}\\frac{d}{dt}']],
  ]
  const functions = [
    ['\\sqrt', '\\sqrt{x}'],
    ['\\sin', '\\sin{x}'],
    ['\\cos', '\\cos{x}'],
    ['\\tan', '\\tan{x}'],
  ]
  const constants = [
    ['\\pi'],
    ['j'],
    ['e'],
  ]


  export default {
    name: 'MathQuillSymbols',

    components: {
      MathQuillView,
    },    

    props: {
      show: {
        required: true,
        type: Boolean,
      },
      customSymbols: {
        type: Array,
        default: () => [],
      },
    },

    data() {
      return {
        operators,
        functions,
        constants,
      }
    },

    methods: {
      opPressed(operator, maskPair) {
        if (maskPair) {
          this.$emit('math-masked-token', maskPair)
        } else {
          this.$emit('math-operator', operator)
        }
      },

      customPressed(val) {
        this.$emit('custom-token', val)
      },
    },
  }
</script>

<style scoped>
  .keyboard {
    background-color: #fcfcfc;
    position: relative;
    top: 0;
    min-width: 300px;
    width: 100%;
    border: 1px solid rgba(0, 0, 0, 0.2);
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.4);
    z-index: 2;
  }

  .keyboard-row {
    list-style-type: none;
    margin: 0;
    padding: 0;
  }

  .keyboard-button {
    display: inline;
  }

  .keyboard-button:hover, .keyboard-math:hover {
    cursor: pointer;
    color: black;
    font-weight: bold;
  }

  .keyboard-math {
    user-select: none;
    margin: 5px;
  }
</style>
